// src/components/ui/NotificationBell.jsx
import { useState, useEffect } from "react";
import { T } from "./index";
import { subscribeNotifications, markNotificationRead } from "../../services/notificationService";
import { useAuth } from "../../contexts/AuthContext";

function fmtTs(ts) {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date((ts.seconds || 0) * 1000);
  const diff = Math.floor((Date.now() - d.getTime()) / 60000);
  if (diff < 1) return "الآن";
  if (diff < 60) return `منذ ${diff}د`;
  if (diff < 1440) return `منذ ${Math.floor(diff/60)}س`;
  return `منذ ${Math.floor(diff/1440)}ي`;
}

const TYPE_ICON = {
  new_offer:      "💰",
  trip_confirmed: "✅",
  deposit_review: "💳",
  trip_completed: "🏁",
  new_trip:       "🚗",
};

export default function NotificationBell() {
  const { user } = useAuth();
  const [notifs, setNotifs] = useState([]);
  const [open,   setOpen]   = useState(false);

  // Admin subscribes to "admin" userId for platform-wide alerts
  const listenId = user?.role === "admin" ? "admin" : user?.id;

  useEffect(() => {
    if (!listenId) return;
    return subscribeNotifications(listenId, setNotifs);
  }, [listenId]);

  const count = notifs.length;

  const handleRead = async (notif) => {
    await markNotificationRead(notif.id);
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: 36, height: 36, borderRadius: 8,
          border: "1px solid rgba(255,255,255,0.18)",
          background: "rgba(255,255,255,0.07)",
          color: "white", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 18, position: "relative", flexShrink: 0,
        }}
        title="الإشعارات"
      >
        🔔
        {count > 0 && (
          <span style={{
            position: "absolute", top: -4, right: -4,
            background: T.danger, color: "white",
            borderRadius: "50%", width: 18, height: 18,
            fontSize: 10, fontWeight: 800,
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "2px solid #0F172A",
          }}>
            {count > 9 ? "9+" : count}
          </span>
        )}
      </button>

      {open && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setOpen(false)}
            style={{ position: "fixed", inset: 0, zIndex: 299 }}
          />
          {/* Dropdown */}
          <div style={{
            position: "absolute", top: 44, left: 0,
            width: 300, maxHeight: 400, overflowY: "auto",
            background: "white", borderRadius: 14,
            boxShadow: "0 8px 32px rgba(0,0,0,.18)",
            border: `1px solid ${T.border}`,
            zIndex: 300,
          }}>
            <div style={{
              padding: "12px 16px", borderBottom: `1px solid ${T.border}`,
              fontWeight: 700, fontSize: 14, display: "flex",
              justifyContent: "space-between", alignItems: "center",
            }}>
              <span>الإشعارات</span>
              {count > 0 && (
                <span style={{ fontSize: 11, color: T.muted, fontWeight: 400 }}>
                  {count} غير مقروء
                </span>
              )}
            </div>

            {notifs.length === 0 && (
              <div style={{ padding: "28px 16px", textAlign: "center", color: T.muted, fontSize: 13 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🔔</div>
                لا توجد إشعارات جديدة
              </div>
            )}

            {notifs.map(n => (
              <div
                key={n.id}
                onClick={() => handleRead(n)}
                style={{
                  padding: "12px 16px", borderBottom: `1px solid ${T.border}`,
                  cursor: "pointer", background: "#FFFBEB",
                  transition: "background .15s",
                  display: "flex", gap: 10, alignItems: "flex-start",
                }}
              >
                <span style={{ fontSize: 20, flexShrink: 0 }}>
                  {TYPE_ICON[n.type] || "🔔"}
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 2 }}>{n.title}</div>
                  <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.4 }}>{n.body}</div>
                  <div style={{ fontSize: 10, color: T.muted, marginTop: 4 }}>{fmtTs(n.createdAt)}</div>
                </div>
                <span style={{ fontSize: 10, color: T.accent, fontWeight: 700, flexShrink: 0 }}>✓ قراءة</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
